<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label" for="question_text">Instructions</label>
      <QuillEditor v-model:content="content.instructions" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="mt-4 mb-4">
      <button class="btn btn-primary" type="button" v-on:click="addInput">Add Input</button>
    </div>
    <div v-if="content.inputs && content.inputs.length > 0" class="mb-4">
      <ol class="list-group">
        <li v-for="(input, index) in content.inputs" :key="index" class="list-group-item">
          <div class="form-group mb-2">
            <label class="control-label">Input Label</label>
            <div class="d-flex align-items-center">
              <input v-model="input.label" class="form-control w-75" placeholder="Input Label" type="text">
              <div class="text-muted w-25 pl-1">token: {{ tokenize(input.label ?? '') }}</div>
            </div>
          </div>
          <div v-if="input.type === 'range'" class="form-group d-flex mb-2">
            <div class="w-50 pr-2">
              <label class="control-label">Left Label</label>
              <input v-model="input.leftLabel" class="form-control" placeholder="Left Label" type="text">
            </div>
            <div class="w-50">
              <label class="control-label">Right Label</label>
              <input v-model="input.rightLabel" class="form-control" placeholder="Right Label" type="text">
            </div>
          </div>
          <div v-if="input.type === 'range'" class="d-flex form-group mb-2">
            <div class="w-25 pr-2">
              <label class="control-label">Min</label>
              <input v-model="input.min" class="form-control" type="number">
            </div>
            <div class="w-25 pr-2">
              <label class="control-label">Max</label>
              <input v-model="input.max" class="form-control" type="number">
            </div>
            <div class="w-25 pr-2">
              <label class="control-label">Default</label>
              <input v-model="input.default" class="form-control" type="number">
            </div>
            <div class="w-25">
              <label class="control-label">Step</label>
              <input v-model="input.step" class="form-control" type="number">
            </div>
          </div>
          <div v-if="input.type === 'select'">
            <div class="form-group mb-2">
              <label class="control-label">Options</label>
              <textarea v-model="input.options" class="form-control"
                        placeholder="Option 1, Option 2, Option 3"></textarea>
            </div>
          </div>
          <div class="form-group w-50">
            <label class="control-label">Type</label>
            <select v-model="input.type" class="form-control">
              <option value="text">Text</option>
              <option value="number">Number</option>
              <option value="range">Range</option>
              <option value="select">Select</option>
            </select>
          </div>
          <button class="btn btn-danger" type="button" @click="content.inputs.splice(index, 1)">
            <i class="fa fa-trash"></i>
          </button>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from '../../mixins/layout'
import {v4 as uuid4} from 'uuid'
import {EDITOR_CONFIG_BUTTONS_FULL, EDITOR_CONFIG_LITE} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {
    QuillEditor
  },
  mixins: [layoutMixin],
  data() {
    return {
      content: _.cloneDeep(this.source),
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
      editorOpts: EDITOR_CONFIG_LITE
    }
  },
  methods: {
    getValue() {
      this.content.inputs.forEach((input) => {
        input.token = this.tokenize(input.label)
      })
      return this.content
    },
    addInput() {
      if (!this.content.inputs) {
        this.content.inputs = []
      }
      this.content.inputs.push({
        label: '',
        leftLabel: '',
        rightLabel: '',
        id: uuid4(),
        min: 0,
        max: 100,
        default: 50,
        step: 1,
        options: '',
      })
    },
    tokenize(label) {
      return `%%${this.pageId}_${label.toLowerCase().replace(/ /g, '_')}%%`
    }
  }

}
</script>
